import React from 'react'
import PropTypes from 'prop-types'
import * as styles from './styles'

const propTypes = {
  data: PropTypes.object.isRequired
}

const RequestAccessForm = ({ data }) => {
  return (
    <styles.RequestAccessFormContainer>
      <form method="POST" target="_blank" action="https://aito.us18.list-manage.com/subscribe/post">
        <input type="hidden" name="u" value="e7ff1392b78623cfdcbda17c8" />
        <input type="hidden" name="id" value="305bbc6e91" />
        {/*
        Autogenerated by mailchimp:
        "Real people should not fill this in and expect good things - do not remove this
        or risk form bot signups"
        */}
        <div style={{ position: 'absolute', left: '-5000px', ariaHidden: 'true' }}>
          <input
            type="text"
            name="b_e7ff1392b78623cfdcbda17c8_305bbc6e91"
            tabIndex="-1"
          />
        </div>
        {/* These names need to match the configuration in Mailchimp */}
        <styles.CustomForm>
          <styles.CustomStyledInput name="EMAIL" type="email" required inputStyle="square" placeholder={data.requestAccessPlaceholder} />
          <styles.CustomStyledFormButton size="small" type="submit">{data.requestAccessButton}</styles.CustomStyledFormButton>
        </styles.CustomForm>
        <styles.DisclaimerText>{data.requestAccessDisclaimer}</styles.DisclaimerText>
      </form>
    </styles.RequestAccessFormContainer>
  )
}

RequestAccessForm.propTypes = propTypes

export default RequestAccessForm
